// External imports
import React from "react";
import { AppBar, Toolbar, Container, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import HideOnScroll from "./HideOnScroll.js";
import { HeaderToggleButton } from "./CustomMUI.js";
import HeaderMenuButton from "./HeaderMenuButton.js";
import { useNavigate } from "react-router-dom";

/**
 * A page's fixed header (hidden on scroll down): menu and/or back button, the
 * title in bold, and any `titleAdornment` (controls) at the far end.
 * `maxWidth` should match the page's own container, so the two line up.
 */
const SimpleHeader = ({
  toggleDrawer,
  drawerWidth,
  title,
  titleAdornment,
  showBackButton,
  showMenu,
  maxWidth = "sm",
}) => {
  const navigate = useNavigate();
  return (
    <>
      <Toolbar sx={{ mt: 2.5 }} />
      {/* The above toolbar acts as a spacer, whatever padding is applied to the below appbar
      needs to be applied as margin to the above spacer, added 0.5 to give space to show librarycard hover scale effects */}
      <HideOnScroll>
        <AppBar
          color="inherit"
          sx={{
            boxShadow: "none",
            backgroundImage: "none",
            width: { md: `calc(100% - ${drawerWidth}px )` },
            ml: { md: `${drawerWidth}px` },
            pt: 2,
            overflowX: "auto",
          }}
        >
          <Container maxWidth={maxWidth}>
            <Toolbar disableGutters>
              {showMenu && (
                <HeaderMenuButton onClick={toggleDrawer} sx={{ mr: 1 }} />
              )}

              {showBackButton && (
                <HeaderToggleButton
                  aria-label="go back"
                  onClick={() => navigate(-1)}
                  size="small"
                  value="back"
                  sx={{
                    mr: 1,
                    "&.MuiButtonBase-root.MuiToggleButton-root": {
                      border: "none",
                      borderRadius: 1,
                    },
                  }}
                >
                  <ArrowBackIcon />
                </HeaderToggleButton>
              )}

              <Typography
                variant="h6"
                sx={{
                  display: "flex",
                  flexGrow: 1,
                }}
              >
                <b>{title}</b>
              </Typography>

              {titleAdornment}
            </Toolbar>
          </Container>
        </AppBar>
      </HideOnScroll>
    </>
  );
};

export default SimpleHeader;
